import { render, staticRenderFns } from "./RejectionReasonAddPage.vue?vue&type=template&id=746083dc&scoped=true&"
import script from "./RejectionReasonAddPage.vue?vue&type=script&lang=ts&"
export * from "./RejectionReasonAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./RejectionReasonAddPage.vue?vue&type=style&index=0&id=746083dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746083dc",
  null
  
)

export default component.exports